import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';
import { ActionsCancelCircleHighlightedLarge } from '@strava/icons';

import { useCheckoutContext } from '../../../../state/CheckoutContext';
import { postRemovePromoCode } from '../../../../state/Checkout.actions';

import styles from './RemovePromoIcon.scss';

export const I18nPrefix =
  'strava.subscriptions.checkout.summary.organic.promo_code.cta';

const RemovePromoIcon = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const { packageIds, duration } = checkoutEntityState;

  const handlePostRemovePromoCode = () => {
    const formData = {
      package_ids: packageIds,
      recurring: duration
    };

    postRemovePromoCode(formData, dispatch);
  };

  return (
    <button
      className={clsx('btn', 'btn-link', styles.actionButton)}
      onClick={handlePostRemovePromoCode}
      type="button"
      aria-labelledby="remove-promo-btn"
    >
      <span id="remove-promo-btn" hidden={true}>
        {I18n.t(`${I18nPrefix}.remove`)}
      </span>
      <ActionsCancelCircleHighlightedLarge />
    </button>
  );
};

export default RemovePromoIcon;
